/**
 * Storage for the bearer token used to authenticate to the admin API.
 *
 * Held in memory for the life of the tab, mirrored to `sessionStorage` so a page reload does not
 * force a re-paste of the token (it still disappears when the tab closes). This module has no
 * opinion on *where the token comes from* — see `getAccessToken` in `client.ts` for that seam.
 */

const STORAGE_KEY = "admin_console_access_token";

let inMemoryToken: string | null = sessionStorage.getItem(STORAGE_KEY);

/** Store the token for subsequent requests. */
export function setToken(token: string): void {
  inMemoryToken = token;
  sessionStorage.setItem(STORAGE_KEY, token);
}

/** Discard the token. Called on logout and whenever the API reports 401. */
export function clearToken(): void {
  inMemoryToken = null;
  sessionStorage.removeItem(STORAGE_KEY);
}

/** The current token, if any. */
export function getToken(): string | null {
  return inMemoryToken;
}
